var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.5 12.5C9.81371 12.5 12.5 9.81371 12.5 6.5C12.5 3.18629 9.81371 0.5 6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.18629 12.5 6.5 12.5Z","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.5002 14.5002L10.7422 10.7422","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Search;

Search.default = Search;
